import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export const StyledPinnacleDatePicker = styled(DatePicker)(({ theme }) => ({
  '& .MuiPickersInputBase-root': {
    color: '#383838',
    '& fieldset': {
      borderColor: 'var(--form-gray-fieldset)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--color-gray-500)',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'var(--form-gray-fieldset) !important',
    },
  },
  '& .MuiPickersOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#C4C4C4',
    },
    '&:hover fieldset': {
      borderColor: '#5840BA',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#5840BA',
    },
    '&.Mui-disabled fieldset': {
      borderColor: '#5840BA',
    },
    '& input': {
      color: '#383838',
    },
    '&.Mui-disabled *': {
      color: '#5840BA !important',
      WebkitTextFillColor: '#5840BA',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#383838',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#383838',
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: '#383838',
  },
  '& .MuiFormHelperText-root': {
    color: '#383838',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: 'var(--form-error-helper)',
  },
}));
